/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1Status } from '../models/Campaignservicev1Status';
import { V1CampaignOrderLine } from '../models/V1CampaignOrderLine';
import { V1PoliticalTransparency } from '../models/V1PoliticalTransparency';
import { HttpFile } from '../http/http';

/**
* Information around a campaign
*/
export class Campaignservicev1Campaign {
    /**
    * ID of Campaign.
    */
    'id'?: string;
    /**
    * Name of Campaign.
    */
    'name'?: string;
    /**
    * Client reference ID.
    */
    'refId'?: string;
    'jobId'?: string;
    'poId'?: string;
    'political'?: boolean;
    'orgId'?: string;
    'createTime'?: Date;
    'updateTime'?: Date;
    'deleteTime'?: Date;
    /**
    * The time the Campaign was archived.
    */
    'archiveTime'?: Date;
    'status'?: Campaignservicev1Status;
    'startTime'?: Date;
    'endTime'?: Date;
    'orderLines'?: Array<V1CampaignOrderLine>;
    'politicalTransparency'?: V1PoliticalTransparency;
    'politicalIndependentExpenditureFormPath'?: string;
    'politicalIndependentExpenditureState'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "refId",
            "baseName": "ref_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "job_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "poId",
            "baseName": "po_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "political",
            "baseName": "political",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "createTime",
            "baseName": "create_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updateTime",
            "baseName": "update_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deleteTime",
            "baseName": "delete_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "archiveTime",
            "baseName": "archive_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "Campaignservicev1Status",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "start_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "end_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "orderLines",
            "baseName": "order_lines",
            "type": "Array<V1CampaignOrderLine>",
            "format": ""
        },
        {
            "name": "politicalTransparency",
            "baseName": "political_transparency",
            "type": "V1PoliticalTransparency",
            "format": ""
        },
        {
            "name": "politicalIndependentExpenditureFormPath",
            "baseName": "political_independent_expenditure_form_path",
            "type": "string",
            "format": ""
        },
        {
            "name": "politicalIndependentExpenditureState",
            "baseName": "political_independent_expenditure_state",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Campaignservicev1Campaign.attributeTypeMap;
    }

    public constructor() {
    }
}

